module.exports = __webpack_public_path__ + "img/wz-5-12.329b2fe9.png";